module.exports = __webpack_public_path__ + "resources/img/img_intel_oneapi.25d56b14b1c3cefe2a8a628f463f9344.png";